/*
 * @Author: linwl 1015547748@qq.com
 * @Date: 2025-12-22 14:27:39
 * @LastEditors: linwl 1015547748@qq.com
 * @LastEditTime: 2026-02-11 16:13:23
 * @FilePath: \mall\src\store\modules\payment\actions\addOrder.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { addOrderApi_V2 } from '@/api/order.js'

/**
 * 处理支付信息，根据支付类型返回相应的参数
 */
const handlePayInfo = (payType, payInfo) => {
  const payTypeMap = {
    cart: {
      sourceType: 'carts_id',
      payGoodsInfo: `[${payInfo}]`
    },
    buyNow: {
      sourceType: 'goods_sn',
      payGoodsInfo: payInfo[0]
    }
  }
  
  return payTypeMap[payType] || {}
}

/**
 * 创建普通商品订单
 */
const addOrderByGoods = async ({ state }, options) => {
  const { paymentType, remark } = options
  const { sourceType, payGoodsInfo } = handlePayInfo(state.payType, state.payInfo)

  const result = await addOrderApi_V2({
    [sourceType]: payGoodsInfo,
    payment_type: paymentType,
    remark,
    address_id: state.addressId
  })
  
  return result.data.data
}

/**
 * 创建蛋糕订单
 */
const addOrderByCake = async ({ state }, options) => {
  const {
    distribution_date,
    distribution_time,
    distribution_type,
    paymentType,
    remark,
    goods_type,
    cake_addr,
    shop_id,
    shop_address,
    shop_name
  } = options

  const result = await addOrderApi_V2({
    address_id: state.addressId,
    goods_sn: state.payInfo[0].goods_size[0],
    payment_type: paymentType,
    distribution_date,
    distribution_time,
    remark: remark || undefined,
    distribution_type: distribution_type || undefined,
    goods_type: goods_type || undefined,
    cake_addr: cake_addr || undefined,
    shop_id,
    shop_name,
    shop_address
  })
  
  return result.data.data
}

const addOrderByMovie = async ({ commit, state }, options) => {
  const { sourceType, payGoodsInfo } = handlePayInfo(state.payType, state.payInfo)

  const {
    movie_name,
    movie_phone,
    paymentType,
    remark,
  } = options ;

  const { seat_ids, show_id } = state.movieInfo 

  console.log(paymentType, 55555)
  // console.log(state.addressId, state.payInfo, seat_ids, show_id, movie_name, movie_phone, remark, goods_sn, address_id)
  
  const result = await addOrderApi_V2({
    [sourceType]: payGoodsInfo,
    address_id: state.addressId,
    payment_type: paymentType,
    movie_name,
    movie_phone,
    seat_ids,
    show_id,
    remark: remark || undefined,
    goods_type: '61'
  })

  return result.data.data
  // return { success: false, result: {} }
}

/**
 * 创建订单（根据商品类型调用不同的下单方法）
 * @param {Object} context - Vuex context
 * @param {Object} params - 订单参数
 * @param {string} params.pay_goods_type - 商品类型（'cake' | 'goods' | ''）
 * @param {number} params.paymentType - 支付方式（1:积分 | 2:余额 | 3:微信 | 20:混合）
 * @param {string} params.movie_name - 电影名称
 * @param {string} params.movie_phone - 电影联系人
 */
const orderAdd = ({ commit, state }, params) => {
  const orderTypeMap = {
    cake: addOrderByCake,
    goods: addOrderByGoods,
    movie: addOrderByMovie
  }
  
  
  const addOrderFn = orderTypeMap[params.pay_goods_type]

  return addOrderFn ? addOrderFn({ commit, state }, params) : Promise.reject(new Error('不支持的商品类型'))
}

export default orderAdd
